import React, { ComponentType, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const withAuth = <P extends object>(WrappedComponent: ComponentType<P>) => {
  const AuthCheckComponent: React.FC<P> = props => {
    const navigate = useNavigate();
    // Add your authentication logic here
    const isAuthenticated = false; // Replace with your actual authentication check

    useEffect(() => {
      if (!isAuthenticated) {
        window.location.href = "/login";
      }
    }, []);

    return <WrappedComponent {...props} />;
  };

  return AuthCheckComponent;
};

export default withAuth;
